






















































import Vue from "vue";
import { ROUTES } from "@/constants/routes";
import URLs from "@/constants/urls";
import { launchToast } from "@/utils/toast";
import { mapGetters } from "vuex";
import { UserStatusLogout } from "@/store/user/types_user";
import { Messages } from "@/constants/messages";
import LoadingDestore from "@/components/LoadingDestore.vue";

export default Vue.extend({
  components:{LoadingDestore},
  data(): {
    HOME_PATH: string;
    REGISTER_PATH: string;
    isLoading: boolean;
    mess: any;
  } {
    return {
      HOME_PATH: ROUTES.HOME.path,
      REGISTER_PATH: ROUTES.REGISTER_APP.path,
      mess: Messages,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(["getUserStatusLogout", "isAuthenticated"]),
  },
  watch: {
    getUserStatusLogout: function () {
      if (this.getUserStatusLogout === UserStatusLogout.loading) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
        if (this.getUserStatusLogout === UserStatusLogout.fail) {
          const toastMessage = this.mess.error_general;
          launchToast(toastMessage);
        }
      }
    },
  },
  methods: {
    goToHome() {
      this.$store.dispatch("changeShowMainComponent", {
        showHome: true,
        showRes: false,
      });
    },
    login() {
      window.location.replace(URLs.url_to_login);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push(ROUTES.HOME.path).catch();
    },
    navigateToRegisterApp() {
      this.$router.push(ROUTES.REGISTER_APP.path);
    },
    confirmLogout() {
      this.$buefy.dialog.confirm({
        title: 'Warning for Soliders',
        message: 'Logging out of DeStore <b>will not</b> log you out of your SOLID account, so next time you will be logged into DeStore automatically.' +
            '<br/><br/> If you want to logout completely, go to your SOLID profile and logout from there.',
        confirmText: 'Logout',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch("logout");
          this.$router.push(ROUTES.HOME.path).catch();
        }
      })
    },
    goToProfile() {
      this.$router.push(ROUTES.PROFILE.path)
    }
  },
});
